'use strict';

var _ = require('lodash');
var GridDuplicateRowButtonController = function GridDuplicateRowButtonController($scope, systemConfigButtonsUtilsService) {
  var DECORATE_FROM_PARENT_ROW = ['fareBrandNormalizationParams', 'fareBrandDefinitionParams', 'fareBrandAssignmentParams'];
  var gridPanel = $scope.gridPanelScope;
  $scope.isGridEditable = gridPanel.jqxGridSettings.editable;
  $scope.isDuplicateButtonShown = false;
  $scope.onRowSelection = function (selectedRows) {
    $scope.isDuplicateButtonShown = !$scope.isDefaultLevel && $scope.isGridEditable && selectedRows.length > 0;
    $scope.selectedRows = selectedRows;
  };
  $scope.duplicateRow = function (oldRow) {
    return _.isFunction($scope.customDuplicate) ? $scope.customDuplicate(oldRow) : cloneNewRow(oldRow);
  };
  function cloneNewRow(oldRow) {
    var newRow = _.cloneDeep(oldRow);
    newRow.isRowEditable = true;
    newRow.isNewlyAdded = true;
    if (DECORATE_FROM_PARENT_ROW.indexOf($scope.parentFieldName) > -1) {
      newRow.carrier = $scope.parentRow.carrier;
    }
    return newRow;
  }
  $scope.duplicateRows = function () {
    _.chain($scope.selectedRows).reverse().forEach(function (selectedRow) {
      systemConfigButtonsUtilsService.addRowToGrid($scope.duplicateRow(selectedRow), gridPanel);
    }).value();
    systemConfigButtonsUtilsService.reloadGrid(gridPanel);
  };
};
GridDuplicateRowButtonController.$inject = ['$scope', 'SystemConfigButtonsUtilsService'];
module.exports = GridDuplicateRowButtonController;